// Defines
var hasFSK18Check       = false;
var fraspy_return_url   = getCookieTlpxx("fraspy_return_url");
var fraspy_has_verified = getCookieTlpxx("fraspy_has_verified");
var fraspy_has_loaded = false;

// Log if customer is logged in
console.log('customerIsLoggedIn: '+customerIsLoggedIn);

// Log customer-tags
console.log('CUSTOMER TAGS:');
console.log($customerTags);

// Check if customer has fsk18 tag
for (item in $customerTags) {
    if ($customerTags[item] == 'FSK18') {
        console.log('FRASPY CUSTOMER HAS FSK18 Tag');
        hasFSK18Check = true;
    }
}

// If customer is logged in and route is /account
document.addEventListener("DOMContentLoaded", function() {
    if (customerIsLoggedIn && window.location.pathname.indexOf("account") >= 1) {
      console.log('FRASPY ACCOUNT EVENT');
      try {
          document.getElementById('ageverify').addEventListener('click', function () {
              //document.querySelector('.showFraspy').style.display = 'block';
              document.getElementById('modal-background-first').style.display = 'block';
              document.getElementById('modal-content-first').style.display = 'block';
          });
  
          document.getElementById('fraspyModalHide').addEventListener('click', function () {
              document.getElementById('modal-background-first').style.display = 'none';
              document.getElementById('modal-content-first').style.display = 'none';
          });
      } catch (e) {}
    }
});

if (customerIsLoggedIn && fraspy_return_url == '/checkout') {
  if (fraspy_has_verified || hasFSK18Check) {
    console.log('FRASPY FORWARD TO CHECKOUT');
    setCookieTlpxx("fraspy_return_url", "", 0);
    setCookieTlpxx("fraspy_has_verified", "", 0);
    //setCookieTlpxx("fraspy_forward_account", "", 0);
    self.location.href = fraspy_return_url;  
  } //else if (!hasFSK18Check && fraspy_return_url == '/checkout' && getCookieTlpxx("fraspy_forward_account") == '') {
    //console.log('FRASPY FORWARD TO ACCOUNT');
    //setCookieTlpxx("fraspy_forward_account", 1, 1);
    //self.location.href = '/account?fraspy_return_url='+fraspy_return_url;
  //}
}

function setCookieTlpxx(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookieTlpxx(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
